import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=4da41350&scoped=true&"
import script from "./ProfileIndex.vue?vue&type=script&lang=ts&"
export * from "./ProfileIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileIndex.vue?vue&type=style&index=0&id=4da41350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da41350",
  null
  
)

export default component.exports